import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AuthenticationService } from '../services/auth.service';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { logout } from 'src/app/modals/Authentication/authentication.actions';
import { LocalStorageService } from '../services/local-storage.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(
        private authenticationService: AuthenticationService, 
        private router: Router, 
        private store: Store,
        private localStorageService: LocalStorageService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError(err => {

                if (
                    err.status === 401 
                ) {
                    // auto logout if 401 response returned from api
                    this.store.dispatch(logout());
                }
                else if (err) { 
                    const handlecode = err?.error?.handlecode;
                    if(handlecode === 1111){
                        this.localStorageService.setItem('2fa_status', "0");
                        this.router.navigate(['auth/two-factor-enable'], { "queryParams": {}});
                    }
                    else if(handlecode === 3333){
                        console.log("here in error 3333");
                        this.localStorageService.setItem('2fa_status', "1");
                        this.router.navigate(['auth/two-factor'], { "queryParams": {}});
                    }
                    else if(handlecode === 4444){
                        this.localStorageService.setItem('2fa_status', "2");
                        this.router.navigate(['auth/setup-password'], { "queryParams": {}});
                    }
                }
                const error = err.error.message || err.statusText;
                return throwError(error);
            })
        )
    }
}
